import React, { useLayoutEffect, useState, useEffect, useRef } from "react";

export default function AnimationBlock(props) {    
    const videoRef = useRef(null);
    const videoRefTwo = useRef(null);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [videoFirstPlay, setVideoFirstPlay] = useState(true);
    const [videoWidth, setVideoWidth] = useState(true);
    const [videoHeight, setVideoHeight] = useState(true);

    useEffect(() => {
        let options = {
            rootMargin: "0px",
            threshold: [0.25, 0.75]
        };

        let handlePlay = (entries, observer) => {
            entries.forEach((entry) => {
            if (entry.isIntersecting) {
                //videoRef.current.currentTime = 1;
                //let endtime = 3;
                if (videoFirstPlay) {
                    videoRef.current?.play();
                }
                
                videoRef.current.addEventListener("timeupdate", function() {
                    /*if (this.currentTime >= endtime) {
                         this.pause();
                    }*/
                    if (this.currentTime >= 4) {
                        setVideoFirstPlay(false);
                    }
                 }, false);

            } else {
                videoRef.current?.pause();
            }
            });
        };

        let observer = new IntersectionObserver(handlePlay, options);

        observer.observe(videoRef.current);
    });

    useEffect(() => {
        
    }, [videoRef]);

    useLayoutEffect(() => {
        setVideoWidth(videoRef.current.offsetWidth);
        setVideoHeight(videoRef.current.offsetHeight);

        console.log(videoRef.current.offsetWidth);
        console.log(videoRef.current.offsetHeight);
    }, []);

    const [videoAnimationMain, setVideoAnimationMain] = useState(true);
    const [videoAnimationFirst, setVideoAnimationFirst] = useState(false);
    const [videoAnimationSecond, setVideoAnimationSecond] = useState(false);
    const [videoAnimationThird, setVideoAnimationThird] = useState(false);
    const [videoAnimationFourth, setVideoAnimationFourth] = useState(false);
    const [videoAnimationFifth, setVideoAnimationFifth] = useState(false);

    const [videoAnimationFirstEnd, setVideoAnimationFirstEnd] = useState(false);
    const [videoAnimationSecondEnd, setVideoAnimationSecondEnd] = useState(false);
    const [videoAnimationThirdEnd, setVideoAnimationThirdEnd] = useState(false);
    const [videoAnimationFourthEnd, setVideoAnimationFourthEnd] = useState(false);
    const [videoAnimationFifthEnd, setVideoAnimationFifthEnd] = useState(false);

    const clickOnFirstBlock = () => {
        setVideoAnimationFirst(true);
        setVideoAnimationSecond(false);
        setVideoAnimationThird(false);
        setVideoAnimationFourth(false);
        setVideoAnimationFifth(false);

        videoRefTwo.current.currentTime = 0;
        let endtime = 1.35;
        videoRefTwo.current?.play();

        /*videoRefTwo.current.addEventListener("timeupdate", function() {
            if (this.currentTime >= endtime) {
                 this.pause();
                 videoRefTwo.current.removeEventListener("mousedown", handleMouseDown, false);
            }
         }, false);*/

         const handleTimeUpdate = function() {
            if (this.currentTime >= endtime) {
                this.pause();
                this.removeEventListener("timeupdate", handleTimeUpdate);
            }
        };
        
        videoRefTwo.current.addEventListener("timeupdate", handleTimeUpdate, false);
    }

    const clickOnFirstEndBlock = () => {
        setVideoAnimationFirstEnd(true);

        videoRefTwo.current.currentTime = 3.35;
        let endtime = 5.68;
        videoRefTwo.current?.play();

        const handleTimeUpdate = function() {
            if (this.currentTime >= endtime) {
                this.pause();
                this.removeEventListener("timeupdate", handleTimeUpdate);
                window.location = 'https://qlogos.io';
            }
        };
        
        videoRefTwo.current.addEventListener("timeupdate", handleTimeUpdate, false);
    }

    const clickOnSecondBlock = () => {
        setVideoAnimationFirst(false);
        setVideoAnimationSecond(true);
        setVideoAnimationThird(false);
        setVideoAnimationFourth(false);
        setVideoAnimationFifth(false);

        videoRefTwo.current.currentTime = 5.75;
        let endtime = 7.08;
        videoRefTwo.current?.play();

        const handleTimeUpdate = function() {
            if (this.currentTime >= endtime) {
                this.pause();
                this.removeEventListener("timeupdate", handleTimeUpdate);
            }
        };
        
        videoRefTwo.current.addEventListener("timeupdate", handleTimeUpdate, false);
    }

    const clickOnSecondEndBlock = () => {
        setVideoAnimationSecondEnd(true);

        videoRefTwo.current.currentTime = 8.78;
        let endtime = 10.38;
        videoRefTwo.current?.play();

        const handleTimeUpdate = function() {
            if (this.currentTime >= endtime) {
                this.pause();
                this.removeEventListener("timeupdate", handleTimeUpdate);
                window.location = 'https://qverse.io';
            }
        };
        
        videoRefTwo.current.addEventListener("timeupdate", handleTimeUpdate, false);
    }

    const clickOnThirdBlock = () => {
        setVideoAnimationFirst(false);
        setVideoAnimationSecond(false);
        setVideoAnimationThird(true);
        setVideoAnimationFourth(false);
        setVideoAnimationFifth(false);

        videoRefTwo.current.currentTime = 10.88;
        let endtime = 12.08;
        videoRefTwo.current?.play();

        const handleTimeUpdate = function() {
            if (this.currentTime >= endtime) {
                this.pause();
                this.removeEventListener("timeupdate", handleTimeUpdate);
            }
        };
        
        videoRefTwo.current.addEventListener("timeupdate", handleTimeUpdate, false);
    }

    const clickOnThirdEndBlock = () => {
        setVideoAnimationThirdEnd(true);

        videoRefTwo.current.currentTime = 13.08;
        let endtime = 15.38;
        videoRefTwo.current?.play();

        const handleTimeUpdate = function() {
            if (this.currentTime >= endtime) {
                this.pause();
                this.removeEventListener("timeupdate", handleTimeUpdate);
            }
        };
        
        videoRefTwo.current.addEventListener("timeupdate", handleTimeUpdate, false);
    }

    const clickOnFourthBlock = () => {
        setVideoAnimationFirst(false);
        setVideoAnimationSecond(false);
        setVideoAnimationThird(false);
        setVideoAnimationFourth(true);
        setVideoAnimationFifth(false);

        videoRefTwo.current.currentTime = 15.58;
        let endtime = 17.08;
        videoRefTwo.current?.play();

        const handleTimeUpdate = function() {
            if (this.currentTime >= endtime) {
                this.pause();
                this.removeEventListener("timeupdate", handleTimeUpdate);
            }
        };
        
        videoRefTwo.current.addEventListener("timeupdate", handleTimeUpdate, false);
    }

    const clickOnFourthEndBlock = () => {
        setVideoAnimationFourthEnd(true);

        videoRefTwo.current.currentTime = 18.88;
        let endtime = 20.42;
        videoRefTwo.current?.play();

        const handleTimeUpdate = function() {
            if (this.currentTime >= endtime) {
                this.pause();
                this.removeEventListener("timeupdate", handleTimeUpdate);
            }
        };
        
        videoRefTwo.current.addEventListener("timeupdate", handleTimeUpdate, false);
    }

    const clickOnFifthBlock = () => {
        setVideoAnimationFirst(false);
        setVideoAnimationSecond(false);
        setVideoAnimationThird(false);
        setVideoAnimationFourth(false);
        setVideoAnimationFifth(true);

        videoRefTwo.current.currentTime = 20.68;
        let endtime = 22.02;
        videoRefTwo.current?.play();

        const handleTimeUpdate = function() {
            if (this.currentTime >= endtime) {
                this.pause();
                this.removeEventListener("timeupdate", handleTimeUpdate);
            }
        };
        
        videoRefTwo.current.addEventListener("timeupdate", handleTimeUpdate, false);
    }

    const clickOnFifthEndBlock = () => {
        setVideoAnimationFifthEnd(true);

        videoRefTwo.current.currentTime = 23.58;
        let endtime = 25.22;
        videoRefTwo.current?.play();

        const handleTimeUpdate = function() {
            if (this.currentTime >= endtime) {
                this.pause();
                this.removeEventListener("timeupdate", handleTimeUpdate);
                window.location = 'https://bayon.io';
            }
        };
        
        videoRefTwo.current.addEventListener("timeupdate", handleTimeUpdate, false);
    }

    const clickOnMainBlock = () => {
        console.log('main')
        setVideoAnimationFirst(false);
        setVideoAnimationSecond(false);
        setVideoAnimationThird(false);
        setVideoAnimationFourth(false);
        setVideoAnimationFifth(false);
    }     

    
    return (     
        <section id="animationVideo" className="animationBlock">
                                    
        {videoAnimationMain && 
        <>
            {/*<div style={{position: "absolute", top: 125, width: "100%", height: 550, zIndex: 3}}>*/}

                {videoAnimationFirst ?  
                <div style={{
                    position: "absolute", 
                    left: videoWidth/3.25,
                    top: videoHeight/6.05,
                    //top: videoHeight/6.75,
                    zIndex: 10,
                    width: videoWidth/5.25,
                    height: videoHeight/3.25, 
                    cursor:"pointer"
                }} onClick={() => {clickOnFirstEndBlock()}}>    
                </div>
                :
                <div style={{
                    position: "absolute", 
                    left: videoWidth/3.25,
                    top: videoHeight/6.05,
                    //top: videoHeight/6.75,
                    zIndex: 10,
                    width: videoWidth/5.25,
                    height: videoHeight/3.25, 
                    cursor:"pointer"
                }} onClick={() => {clickOnFirstBlock()}}>    
                </div>                
                }
                {videoAnimationSecond ?  
                <div style={{
                    position: "absolute", 
                    right: videoWidth/3.25,
                    top: videoHeight/6.05,
                    //top: videoHeight/6.75,
                    zIndex: 10,
                    width: videoWidth/5.25,
                    height: videoHeight/3.25, 
                    cursor:"pointer"
                }} onClick={() => {clickOnSecondEndBlock()}}>
                </div>
                :
                <div style={{
                    position: "absolute", 
                    right: videoWidth/3.25,
                    top: videoHeight/6.05,
                    //top: videoHeight/6.75,
                    zIndex: 10,
                    width: videoWidth/5.25,
                    height: videoHeight/3.25, 
                    cursor:"pointer"
                }} onClick={() => {clickOnSecondBlock()}}>
                </div>
                } 
                {videoAnimationThird ?  
                <div style={{
                    position: "absolute", 
                    left: videoWidth/3.44,
                    top: videoHeight/1.92,
                    //top: videoHeight/2.12,
                    zIndex: 10,
                    width: videoWidth/9.04,
                    height: videoHeight/3.85, 
                    cursor:"pointer"
                }} onClick={() => {clickOnThirdEndBlock()}}>
                
                </div>
                :
                <div style={{
                    position: "absolute", 
                    left: videoWidth/3.44,
                    top: videoHeight/1.92,
                    //top: videoHeight/2.12,
                    zIndex: 10,
                    width: videoWidth/9.04,
                    height: videoHeight/3.85, 
                    cursor:"pointer"
                }} onClick={() => {clickOnThirdBlock()}}>
                
                </div>
                }
                {videoAnimationFourth ?  
                <div style={{
                    position: "absolute", 
                    left: videoWidth/2.44,
                    top: videoHeight/1.92,
                    //top: videoHeight/2.12,
                    zIndex: 10,
                    width: videoWidth/5.25,
                    height: videoHeight/3.25, 
                    cursor:"pointer"
                }} onClick={() => {clickOnFourthEndBlock()}}>
                    
                </div>
                :
                <div style={{
                    position: "absolute", 
                    left: videoWidth/2.44,
                    top: videoHeight/1.92,
                    //top: videoHeight/2.12,
                    zIndex: 10,
                    width: videoWidth/5.25,
                    height: videoHeight/3.25, 
                    cursor:"pointer"
                }} onClick={() => {clickOnFourthBlock()}}>
                    
                </div>
                }
                {videoAnimationFifth ? 
                <div style={{
                    position: "absolute", 
                    right: videoWidth/3.44,
                    top: videoHeight/1.92,
                    //top: videoHeight/2.12,
                    zIndex: 10,
                    width: videoWidth/9.04,
                    height: videoHeight/3.85, 
                    cursor:"pointer"
                }} onClick={() => {clickOnFifthEndBlock()}}>
                </div>
                :
                <div style={{
                    position: "absolute", 
                    right: videoWidth/3.44,
                    top: videoHeight/1.92,
                    //top: videoHeight/2.12,
                    zIndex: 10,
                    width: videoWidth/9.04,
                    height: videoHeight/3.85, 
                    cursor:"pointer"
                }} onClick={() => {clickOnFifthBlock()}}>
                </div>
                }
                
            {/*</div>*/}

            <video style={{width: "100%", position: "relative", zIndex: 1}} playsInline muted ref={videoRef}>
                <source src="/video/Opening.mp4" type="video/mp4" />
            </video>
            {!videoFirstPlay && 
            <video style={{width: "100%", position: "absolute", top: 0, left: 0, zIndex: 2}} playsInline muted ref={videoRefTwo}>
                <source src='/video/qmenu.mp4' type="video/mp4" />
            </video>
            }
        </>
        }
        </section>
    );
}